'use client'
import { getGlobalContent } from '@/lib/strapi';
import React from 'react';
import Footer from '@/app/components/Footer';
import Header from '@/app/components/Header';
import Modals from '@/app/components/Modals';
import Head from 'next/head';

export async function getStaticProps() {
	const isDev = process.env.NODE_ENV === 'development' || process.env.APP_MODE === 'staging';
	const store = isDev ? 'dev' : 'us';
	const preview = store === 'dev' ? 'staging' : '';
    return {
        props: {
            ...await getGlobalContent({ preview, store }),
			envStore: store,
        },
        revalidate: 300,
    }
}

export default function Custom404(props:any) {
	const { envStore, swellLoyalty, annBar, store, timerBar, generalSetting, mainNav, menuBannerCode, menuBannerQuiz, searchBox, aboutNav, shopNav, helpNav } = props;

	return (<>
				<Head>
                	<title>Award Winning Bali Beauty Products - Natural & Effective | Coco & Eve</title>
				</Head>
				<Header
				annBar={{...annBar, enabled: false}}
				timerBar={timerBar}
				generalSetting={generalSetting}
				mainNav={mainNav}
				menuBannerQuiz={menuBannerQuiz}
				menuBannerCode={menuBannerCode}
				searchBox={searchBox}
				swellLoyalty={swellLoyalty}
				envStore={envStore}
			/>
				<div className="
					bg-no-repeat bg-cover bg-[center_top] block py-[25.5px] px-[17px] lg:py-[75px] lg:px-4">
						<div className="section-header section-header--404 pb-[60px]">
							<div className="rte text-spacing text-center">
								<h1 className="mb-1 text-[#1a736a] lg:text-[64px]">OH NO!</h1>
								<p className='mx-auto max-w-[600px]'>We couldn’t find the page you’re searching for! Let’s sail you back to paradise by clicking the button below.</p>
								<picture className="w-100 flex flex-wrap justify-center my-4">
									<source media="(min-width: 992px)" srcSet="https://imagedelivery.net/ghVX8djKS3R8-n0oGeWHEA/5630e690-175e-4d9a-28b8-149a3ae2a000/420x" />
									<img src="https://imagedelivery.net/ghVX8djKS3R8-n0oGeWHEA/5630e690-175e-4d9a-28b8-149a3ae2a000/614x" />
								</picture>
								<a href="/" className="btn btn-primary border-primary hover:text-white hover:no-underline rounded-full mt-3">BACK TO HOMEPAGE</a>
								<p className="mb-[1rem]"></p>
							</div>
						</div>
					</div>

				<Footer
				aboutNav={aboutNav}
				shopNav={shopNav}
				helpNav={helpNav}
				envStore={envStore}
			/>
			{/* don't delete below line, for tailwind colors compiling purposes*/}
			<div className='hidden
				bg-yellow-dark text-yellow-dark
				bg-yellow-light text-yellow-dark
				bg-skincare-orange-dark text-skincare-orange-dark
				bg-bali-bod-blue-light text-bali-bod-blue-light
				bg-primary-darken text-primary-darken
				bg-secondary-darken text-secondary-darken
				bg-blue-dark text-blue-dark
				bg-sh-purple text-sh-purple
				 bg-pink-light text-pink-light
				 bg-sh-orange text-sh-orange
				 bg-green-light text-green-light
				bg-bali-bod-blue text-bali-bod-blue
				bg-light-blue text-light-blue
				bg-light-yellow text-light-yellow
				bg-suncare-blue text-suncare-blue
				bg-blue text-blue
				'></div>
			<Modals store={store} />
	</>)
}
